import script from "./ArrearsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrearsTable.vue?vue&type=script&setup=true&lang=js"

import "./ArrearsTable.vue?vue&type=style&index=0&id=5a5908e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5908e2"]])

export default __exports__